export const steps = ['Step 1', 'Step 2'];

export const defaultValues = {
  email: '',
  firstName: '',
  businessName: '',
  password: '',
  country: '',
  industryCode: '',
  companySize: ''
};

//IMPORTANT: if adding (or editing?) values below, make sure to add them to both prod and pre-prod hubspot accounts, with display name and 'code' the same as below
export const industryData = [
  { name: 'Aviation' },
  { name: 'Travel' },
  { name: 'Events' },
  { name: 'E-commerce' },
  { name: 'Other' },
];

//IMPORTANT: if adding (or editing?) values below, make sure to add them to both prod and pre-prod hubspot accounts, with display name and 'code' the same as below
export const companySizeData = [
  { name: 'Self-employed' },
  { name: '2-10 employees' },
  { name: '11-50 employees' },
  { name: '51-200 employees' },
  { name: '201-500 employees' },
  { name: '501-1000 employees' },
  { name: '1001-5000 employees' },
  { name: '5001-10,000 employees' },
  { name: '10,001+ employees' },
]

export const modifyCompanySizeData = (companySize: string) => {
  if (companySize && companySize === 'Self-employed') {
    return '1'
  } else if (companySize && companySize === '2-10 employees') {
    return '10' // needed to be 10 for the backend, especially hubspot field which has this value instead of a range (for some reason...)
  }else {
    return companySize.replace(' employees', '')
  }
}